// extracted by mini-css-extract-plugin
module.exports = {"pdf-preview":"pdf-preview___PTK0K","pdf-image":"pdf-image___3vQIT","pdf-asset-icon":"pdf-asset-icon___1Ku7h"};